export function isMatchKeyword(target, keyword) {
    // 値がない場合
    if (!target) {
        return false;
    }
    // キーワード未入力の場合
    if (!keyword?.trim()) {
        return true;
    }
    return target
        .toString()
        .normalize("NFKC")
        .toLowerCase()
        .trim()
        .includes(keyword.normalize("NFKC").toLowerCase().trim());
}
